import { useLocation, Navigate } from "react-router-dom";
import SellBrandPage from "@/pages/SellBrandPage";
import { SELL_BRAND_RE } from "@/lib/routes";
import SEO from "@/components/SEO";

export default function NotFoundOrSellBrand() {
  const { pathname } = useLocation();
  if (SELL_BRAND_RE.test(pathname)) {
    return <SellBrandPage />;
  }
  return (
    <>
      <SEO title="Page not found" description="The page you were looking for was moved or doesn't exist. Head back to the GC SPARK home page." noindex />
      <Navigate to="/" replace />
    </>
  );
}
